// useTenantLoginPolicy — one tenant's login policy, for a signed-in screen.
//
// Ported from Frontend-web/src/hooks/useTenantLoginPolicy.js (not a mirrored
// file). "How they sign in" on a tenant admin's profile colours a "Not
// verified" pill red only where that admin's tenant demands a code for the
// channel (owner, 1 Oct 2026); elsewhere it is a neutral grey. The answer is
// GET /tenants/public?tenantId=… → loginPolicy. Until it arrives (or when it
// cannot be read) the platform DEFAULT_POLICY stands, exactly as on every
// other policy-shaped screen. With no tenantId nothing is fetched — the
// caller decides whether a policy applies at all (the Super Admin's own
// profile has no tenant and passes none).

import { useEffect, useState } from 'react';
import createAuthedAxios from './useAxiosAuth';
import baseURL from '../utils/baseURL';
import { policyFor } from '../utils/loginPolicy';

export default function useTenantLoginPolicy(tenantId) {
    const [tenants, setTenants] = useState([]);
    useEffect(() => {
        if (!tenantId) return undefined;
        let alive = true;
        Promise.resolve()
            .then(() => createAuthedAxios().get(`${baseURL}/tenants/public`, { params: { tenantId } }))
            .then((res) => { if (alive) setTenants(res?.data?.tenants || []); })
            .catch(() => { if (alive) setTenants([]); });
        return () => { alive = false; };
    }, [tenantId]);
    return policyFor(tenants, tenantId || '');
}
